export enum MembershipPurchaseType {
  recurring = 'REC',
  prepaid = 'PRE',
  benefit = 'BEN',
}

export enum MembershipInterval {
    daily = 'DAI',
    weekly = 'WKL',
    biweekly = 'BWK',
    fourWeeks = '4WK',
    monthly = 'MON',
    quarterly = 'QTR',
    halfYearly = 'HYR',
    yearly = 'YEA'
}

export enum MembershipStatus {
    draft = 'DRA',
    active = 'ACT',
    retired = 'RET'
}

export enum MembershipDiscountApplyMethod {
    automatic = 'AUT',
    code = 'COD',
    referral = 'REF',
    cancellation = 'CAN',
    bankTransfer = 'BAN',
    freeze = 'FRZ',
}

export enum MembershipDiscountType {
    currency = 'CUR',
    percentage = 'PER'
}

export enum MembershipGiftDiscountType {
    currency = 'CUR',
    percentage = 'PER'
}

export enum MembershipVisibility {
    public = 'PUB',
    unlisted = 'UNL',
    staffOnly = 'STA'
}

export enum CustomerMembershipStatus {
    awaitingInitialPayment = 'PAY',
    initialPaymentProcessing = 'IPP',
    initialPaymentCancelled = 'IPC',
    // Paid for in full, but not active: recurring, owes a future payment, and
    // has no payment method saved to collect it with (PRO-1460).
    awaitingPaymentMethod = 'APM',
    deniedStaffApproval = 'DEN',
    active = 'ACT',
    frozen = 'FRZ',
    renewalPaymentPending = 'PPE',
    renewalPaymentProcessing = 'PPR',
    renewalPaymentFailed = 'PAF',
    freezePaymentPending = 'FPE',
    freezePaymentProcessing = 'FPR',
    freezePaymentFailed = 'FPF',
    ended = 'END'
}
